var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: _vm.language["emp.apptype.apptypeName"]
                  }
                },
                [
                  _c("a-input", {
                    attrs: { readOnly: "", disabled: "" },
                    model: {
                      value: _vm.model.appTypeName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "appTypeName", $$v)
                      },
                      expression: "model.appTypeName"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["portal.unitApp"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "selectedApps"
                  }
                },
                [
                  _c("j-multi-select-tag", {
                    attrs: {
                      maxTagCount: 20,
                      options: _vm.appsOptions,
                      disabled: _vm.disableSubmit,
                      placeholder:
                        _vm.language["common.pleaseChoose"] +
                        _vm.language["portal.unitApp"]
                    },
                    model: {
                      value: _vm.model.selectedApps,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "selectedApps", $$v)
                      },
                      expression: "model.selectedApps"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }